import React, { Component } from 'react'
import Link from 'gatsby-link'
import TheCrux from '../assets/images/The_Crux.png'
import TheFinale from '../assets/images/The_Finale.png'
import ThePrologue from '../assets/images/The_Prologue.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDotCircle } from '@fortawesome/free-solid-svg-icons'


class CurrentBundle extends Component {
    render() {
        return (
            <section>
                <div className="container">
                    <div className="columns">
                        <div className="column"></div>
                        <div className="column is-two-thirds">
                            <div className="content m-t-xl">
                                <div className="is-size-3 has-text-centered has-text-weight-bold">Inaugural Bundle</div>
                                <div className="has-text-centered"><span className="has-text-primary is-size-3 has-text-weight-bold">Bourbon Tasting</span></div>
                                <div className="is-size-5 has-text-centered m-t-lg">Hosting a great party is about starting a story.</div>
                                <div className="is-size-5 has-text-centered">Choose the bundle that is right for you.</div>
                            </div>
                        </div>
                        <div className="column"></div>
                    </div>
                    <div className="columns">
                        <div className="column m-t-lg has-text-centered has-text-weight-bold">
                            <p className="is-size-1"><img src={ThePrologue} /></p>
                            <div className="price-list">The Prologue</div>
                            <div className="price-list">$75</div>
                            <div className="has-text-centered">
                                <a href="https://backyardbundles.myshopify.com/collections/bourbon-party-bundles/products/the-prologue" className="button is-primary is-medium">Buy Bundle</a>
                            </div>
                        </div>
                        <div className="column m-t-lg has-text-centered has-text-weight-bold">
                            <p className="is-size-1"><img src={TheCrux} /></p>
                            <div className="price-list">The Crux</div>
                            <div className="price-list">$250</div>
                            <div className="has-text-centered">
                                <a href="https://backyardbundles.myshopify.com/collections/bourbon-party-bundles/products/the-crux" className="button is-primary is-medium">Buy Bundle</a>
                            </div>
                        </div>
                        <div className="column m-t-lg  has-text-centered has-text-weight-bold">
                            <p className="is-size-1"><img src={TheFinale} /></p>
                            <div className="price-list">The Finale</div>
                            <div className="price-list">$530</div>
                            <div className="has-text-centered">
                                <a href="https://backyardbundles.myshopify.com/collections/bourbon-party-bundles/products/the-finale" className="button is-primary is-medium">Buy Bundle</a>
                            </div>
                        </div>
                    </div>
                    
                    <div className="content">
                        <div className="columns is-centered">
                            <div className="column is-half m-t-xl m-b-xl">
                                <p className="is-size-3 has-text-centered">Each bundle provides you with</p>
                                <div id="bundle-content">
                                    <ul>
                                        <li><FontAwesomeIcon icon={faDotCircle} size="1x" className="bullets" /><span className="box-items">High quality reusable decor to continue the story after the party</span></li>
                                        <li><FontAwesomeIcon icon={faDotCircle} size="1x" className="bullets" /><span className="box-items">Classy disposables to set your event apart.</span></li>
                                        <li><FontAwesomeIcon icon={faDotCircle} size="1x" className="bullets" /><span className="box-items">Activity cards to keep the party moving.</span></li>
                                        <li><FontAwesomeIcon icon={faDotCircle} size="1x" className="bullets" /><span className="box-items">A hostess toolkit to keep you organized and on schedule.</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                        
                </div>
            </section>
        );
    }
}


export default CurrentBundle


// WEBPACK FOOTER //
// ./src/components/currentBundle.js